(function () {
    'use strict';
    angular
        .module('app')
        .directive('inputBox', inputBox);
    inputBox.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function inputBox($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'inputBox',
            templateUrl: 'app/msgBox/inputBox.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();